export const ROLES = {
  INVESTOR: 'investor',
  OWNER: 'owner',
  ADVISOR: 'advisor',
  FIRM: 'firm',
  BANKER: 'banker',
} as const;

export type Role = (typeof ROLES)[keyof typeof ROLES];

export function isAdvisorUserRole(role?: string | null): boolean {
  return (role ?? '').toLowerCase() === ROLES.ADVISOR;
}

const ROLES_WITHOUT_USER_PROFILE: readonly string[] = [
  'administrator',
  ROLES.FIRM,
  'team member',
];

export function hasUserProfile(role?: string | null): boolean {
  if (!role) return false;
  return !ROLES_WITHOUT_USER_PROFILE.includes(role.toLowerCase());
}
